import Repository from '../axios'

const resource = "/admin/ul";

export default {
  getFormulationLabel(code) {
    return Repository.get(`${resource}/labels?product=${code}&languages=BE,FR&rows=10000000&subformat=OAPI`)
  },
  getFormulationSdsDocument(code) {
    return Repository.get(`${resource}/DEMO-EMPTY/document`)
  }
};
